import type { BranchDeliveryDiscountType } from '@/backend/market'

export class DeliveryBranchMiniEntity {
  id?: string
  name?: string | null
  type?: BranchDeliveryDiscountType
  priority?: number | null
  startDate?: string | null
  endDate?: string | null
  isActive?: boolean
}
